// @ts-nocheck

/**
 * * `cover` - cover
 * `contain` - contain
 * `fill` - fill
 * `none` - none
 */
export type FitModeEnum = typeof FitModeEnum[keyof typeof FitModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FitModeEnum = {
  cover: "cover",
  contain: "contain",
  fill: "fill",
  none: "none",
} as const;
